/* eslint-disable */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VeeValidate from 'vee-validate'
import UUID from "vue-uuid";

import { router } from './router'
import { store } from './store'

// import Toast from './plugins/toast'
import Toast from "./plugins/toast2";

import Alert from './plugins/alert'
import Panel from './plugins/panel'
import SignalR from './plugins/signalr'

import Debounce from 'v-debounce'

// orig
//import { VueSlideoutPanel } from 'vue2-slideout-panel'
//Vue.component('slideout-panel', VueSlideoutPanel)
// /orig

// local
import VueSlideoutPanel from './components/vue-slideout-panel'
Vue.component('slideout-panel', VueSlideoutPanel.VueSlideoutPanel)
// /local

import SlideUpDown from 'vue-slide-up-down'
Vue.component('slide-up-down', SlideUpDown)

import Vuex from 'vuex'

import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import TextareaAutosize from 'vue-textarea-autosize'

// Import layouts
import AdminLayout from './components/layouts/AdminLayout'
import LoginLayout from './components/layouts/LoginLayout'
import EmptyLayout from './components/layouts/EmptyLayout'

import './assets/styles/app.scss'

// Mixins
import moment from 'moment-business-days'
Vue.filter('dateTime', function(value) {
  if (value) {
    // return moment(String(value)).format('YYYY-MM-DD HH:mm')
    return moment.utc(String(value)).local().format('YYYY-MM-DD HH:mm') // UTC » Local
  }
})

Vue.filter('date', function(value) {
  if (value) {
    return moment(String(value)).local().format('YYYY-MM-DD')
  }
})

// Vue.use(Toast)

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
})

Vue.use(Alert)
Vue.use(Panel)
Vue.use(SignalR)
Vue.use(UUID)
Vue.use(TextareaAutosize)

Vue.use(Vuex)
// Vue.use(require('vue-moment'))
// Vue.use(moment)
Vue.prototype.$moment = moment;
Vue.use(VeeValidate)

// Loadash is used to compare objects reliably, see AgileTableActions filter
Vue.use(VueLodash, { name: 'custom', lodash: lodash })

// Directives
Vue.directive('debounce', Debounce)
import { directive as onClickOutside } from 'vue-on-click-outside'
Vue.directive('click-outside', onClickOutside)

// Dev
import { Fragment } from 'vue-frag'
Vue.component('fragment', Fragment)
import Dev from '@/components/other/Dev'
Vue.component('dev', Dev)

// Layouts
Vue.component('admin-layout', AdminLayout)
Vue.component('login-layout', LoginLayout)
Vue.component('empty-layout', EmptyLayout)

const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)

Vue.config.productionTip = false

window.isElectron = function () {
  return 'Bridge' in window
}

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

/* eslint-disable no-new, no-unused-vars */
var v = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js